import React, { useEffect, useState } from 'react';
import { Row, Col, message } from 'antd';
import { CheckCircleOutlined, FrownOutlined, LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import jwt from 'jsonwebtoken';
import Authorize from '../api/api-authorize';
import './styles.less';
import IdentificationType from '../../../enums/identificationType';

const AuthorizeMail = ({ token }) => {
  const [requestStatus, setRequestStatus] = useState();

  const { declaringPerson } = jwt.decode(token);

  const authorizeWithToken = () => {
    const payload = {
      token,
    };
    Authorize.authorizeEmail(payload)
      .then(() => {
        setRequestStatus('success');
      })
      .catch(() => {
        message.error('Error inesperado. Por favor, intente nuevamente.');
        setRequestStatus('failed');
      });
  };

  useEffect(() => {
    authorizeWithToken();
    setRequestStatus('fetching');
  }, []);

  return (
    <div>
      {requestStatus === 'fetching' && (
        <div>
          <Row className="authorizeMail" justify="center">
            <Col>
              <Row justify="center">
                <Col className="authorizeMail__title">
                  <LoadingOutlined style={{ color: '#B22938', fontSize: '26px' }} /> Autorizando...
                </Col>
              </Row>
              <Row justify="center">
                <Col lg={18} className="authorizeMail__text">
                  Espere un momento, estamos enviando el código a la persona que lo enrolará como
                  cliente.
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
      {requestStatus === 'success' && (
        <div>
          <Row className="authorizeMail" justify="center">
            <Col>
              <Row justify="center">
                <Col className="authorizeMail__title">El código ha sido enviado con éxito</Col>
              </Row>
              <Row justify="center">
                <Col>
                  <CheckCircleOutlined
                    style={{ fontSize: '60px', color: '#c0c0c0', marginBottom: 25, marginTop: 20 }}
                  />
                </Col>
              </Row>
              <Row justify="center">
                <Col lg={9} className="authorizeMail__text">
                  Se ha autorizado su enrolamiento como cliente Vantrust Capital. La solicitud será
                  realizada por {declaringPerson.name},{' '}
                  {declaringPerson.identificationType === IdentificationType.OTRO
                    ? 'Identifcación'
                    : declaringPerson.identificationType}{' '}
                  {declaringPerson.identification}, correo electrónico
                  {declaringPerson.email}.
                </Col>
              </Row>
              <Row justify="center">
                <Col lg={9} className="authorizeMail__text authorizeMail__text--contact">
                  Si necesita asistencia, comuníquese con su ejecutivo o escriba a
                  <span className="authorizeMail__contact"> contacto@vantrust.cl</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
      {requestStatus === 'failed' && (
        <div>
          <Row className="authorizeMail" justify="center">
            <Col>
              <Row justify="center">
                <Col className="authorizeMail__title">¡Vaya! Algo salió mal</Col>
              </Row>
              <Row justify="center">
                <Col>
                  <FrownOutlined
                    style={{ fontSize: '60px', color: '#c0c0c0', marginBottom: 25, marginTop: 20 }}
                  />
                </Col>
              </Row>
              <Row justify="center">
                <Col lg={16} className="authorizeMail__text">
                  No se pudo enviar el código. Cierre esta página e intente nuevamente por favor.
                </Col>
              </Row>
              <Row justify="center">
                <Col lg={18} className="authorizeMail__text authorizeMail__text--contact">
                  Si necesita asistencia, comuníquese con su ejecutivo o escriba a
                  <span className="authorizeMail__contact"> contacto@vantrust.cl</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

AuthorizeMail.propTypes = {
  token: PropTypes.string.isRequired,
};

export default AuthorizeMail;
